// import tools from './tool'

let prefix = "pc_prefix"; //短信前缀
let timeNum = 0; //时间开始时间，N天前开始查 -30==30天内的时间
let pageTotals = 50; //每页条数

let domain = "";
let baseURL = "";
// 测试
let appid = "";
let appsecret = "";


 let isTest = true; //测试服务器
 isTest = false   //正式服务器


if (isTest) {
  // 测试环境
  appid = "hy7vptfjxs6zhwsowz";
  appsecret = "1f29443847dabd29ef06c319f21fcecf";
  baseURL = "http://localhost:8085"; //测试服务器
  //baseURL = "http://192.168.1.11:8081"; //测试服务器
  //baseURL = "https://dev.b9.api.8bami.com"; //测试服务器
} else {
  // 生产环境
  appid = "hycfguwlmgiudvrp20";
  appsecret = "b77c289819a812a18aadf26425e5bc45";
  //baseURL = "http://api.lianchengwuliu.com"; //正式服务器 (联城)
  baseURL = 'http://api.liancheng.8bami.com'; //正式服务器 (八米)
}

// let EnterpriseNo = 'heshitms' //测试;

let serve_s = "build"; //dev==开发环境 ,build==发布打包
if (process.env.NODE_ENV === "development") {
  // 开发环境
  serve_s = "dev";
} else {
  serve_s = "build";
  // tms
}

let uploadUrl = baseURL + "/base/saas/v1/file/upload"; //文件上传接口

export default {
  baseURL,
  appid,
  appsecret,
  uploadUrl,
  prefix,
  serve_s,
  domain,
  timeNum: timeNum, //10天前的时间
  userInfo: {},
  isTest, //是否测试服务器的
  pageTotals,
};
